import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Testimoniol() {

    const settings = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      };


    const peopleData = [
        {
          "name": "Mark R.",
          "profile" : "images/illustration/testimonial.png",
          "role": "Real Estate Investor",
          "description": "PropertySearch.AI has completely transformed the way I find investment properties. The AI-driven insights and ROI heat-maps help me make informed decisions quickly. It’s a must-have tool for serious investors!"
        },
        {
          "name": "Sarah L.",
          "profile" : "images/agent-23.jpg",
          "role": "Homebuyer",
          "description": "Searching for my dream home was never this easy! The platform’s intuitive interface and smart recommendations helped me find the perfect property within my budget. Highly recommended!"
        },
        {
          "name": "David M.",
          "profile" : "images/agent-28.jpg",
          "role": "Real Estate Agent",
          "description": "As a real estate professional, PropertySearch.AI has been a game-changer. It allows me to analyze market trends, compare properties, and provide better recommendations to my clients in minutes."
        },
        {
          "name": "Priya S.",
            "profile" : "images/agent-29.jpg",
          "role": "Property Consultant",
          "description": "I love how PropertySearch.AI simplifies property research. The AI-powered analysis and detailed market data give me an edge in advising my clients on the best investment opportunities."
        }
      ]
      
  return (
    <section class="main-people-living">
    <section class="people-living mb-5 ">
      <div class="container">
        <div class="people-living-text pt-5 d-sm-flex justify-content-between mb-4">
          <div>
            <h5>People Love Living Us</h5>
            <p>People who love us & he says good reviews</p>
          </div>
          {/* <div>
            <a href="#">
              View all testimonials <i class="bi bi-caret-right-fill"></i>
            </a>
          </div> */}
        </div>
        <div class="people-living-content  justify-content-between">
        <Slider {...settings}>
        {peopleData.map((person, index) => (
          <div class="card mb-2">
            <div class="card-body">
              <div class="d-flex">
                <div>
                  <img
                    class="testimonial-img border rounded-circle"
                    src={person.profile}
                    alt=""
                  />
                </div>
                <blockquote class="blockquote ">
  <p class="mb-2">{person.name}</p>
  <footer class="blockquote-footer"> <cite title="Source Title">{person.role}</cite></footer>
</blockquote>
              </div>
              <p class="card-text-testimonial ">
              {person.description}
              </p>
            </div>
          </div>
        ))}
       </Slider>
        </div>
      </div>
    </section>
  </section>
  )
}

export default Testimoniol